import React from "react"
import i18n from "@/i18n"
import PostButton from "@/components/post_button"
import { OAUTH_PROVIDERS } from "./oauth_providers"

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
      fill="#4285F4"
    />
    <path
      d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.26c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9.002 18z"
      fill="#34A853"
    />
    <path
      d="M3.964 10.712A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.33z"
      fill="#FBBC05"
    />
    <path
      d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29c.708-2.127 2.692-3.71 5.036-3.71z"
      fill="#EA4335"
    />
  </svg>
)

const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 9a9 9 0 1 0-10.406 8.89v-6.29H5.309V9h2.285V7.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.176 2.014.176v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V9h2.496l-.399 2.6h-2.097v6.29A9.002 9.002 0 0 0 18 9z"
      fill="#1877F2"
    />
  </svg>
)

const PROVIDER_ICONS: Record<string, React.ReactNode> = {
  google: <GoogleIcon />,
  facebook: <FacebookIcon />,
}

type OAuthButtonsProps = {
  googleEnabled: boolean
  facebookEnabled: boolean
}

const OAuthButtons: React.FC<OAuthButtonsProps> = ({ googleEnabled, facebookEnabled }) => {
  const enabledKeys = new Set([googleEnabled && "google", facebookEnabled && "facebook"].filter(Boolean) as string[])

  const enabledProviders = OAUTH_PROVIDERS.filter((p) => enabledKeys.has(p.key))

  if (enabledProviders.length === 0) return null

  return (
    <div data-testid="auth-signin-oauth-section">
      <div className="flex flex-col gap-3">
        {enabledProviders.map((provider) => (
          <PostButton
            key={provider.key}
            action={provider.action}
            variant="outlined"
            color="inherit"
            fullWidth
            className="justify-start gap-2 normal-case font-normal"
            startIcon={PROVIDER_ICONS[provider.key]}
            data-testid={provider.testId}
          >
            {i18n.t(provider.labelKey)}
          </PostButton>
        ))}
      </div>

      <div className="flex items-center my-4 w-full">
        <div className="flex-1 border-t border-gray-300" />
        <span className="px-4 text-gray-500 text-sm">{i18n.t("app.auth.login.or")}</span>
        <div className="flex-1 border-t border-gray-300" />
      </div>
    </div>
  )
}

export default OAuthButtons
